import { Typography } from '@material-ui/core';
import React from 'react';
import { utcToZonedTime } from 'date-fns-tz';
import { HskDelayResponse } from '../../types';
import { formatReadTimestamp } from '../../util';
import { usePincodesStyles } from './PinCodes';

type Props = { hskDelay: HskDelayResponse; timezone: string };

const HskDelay: React.FC<Props> = ({ hskDelay, timezone }) => {
    const classes = usePincodesStyles();
    const zonedDelayUntil = utcToZonedTime(hskDelay.delayUntil, timezone);

    return (
        <div className={classes.container}>
            <Typography component="span">Housekeeping delay set for <strong>{formatReadTimestamp(zonedDelayUntil, 'dd.mm.yyyy hh:MM TT')}</strong></Typography>
        </div>
    );
}

export default HskDelay;
